import { Injectable } from '@angular/core';

@Injectable()
export class TimeHelperService {
  constructor() {}

  /**
   * This function uses the JavaScript Date object to calculate the time difference between the input date time and the current time,
   * and then checks if the time difference is greater than 24 hours.
   * @param newDateTime
   * @param hours
   */
  isDateTimeMoreThanXHoursOld(newDateTime: Date, hours): boolean {
    // Calculate the difference between the input date time and the current time
    // @ts-ignore
    const timeDiff = new Date() - new Date(Date.parse(newDateTime));

    // Convert the time difference from milliseconds to hours
    const hoursDiff = timeDiff / (1000 * 60 * 60);

    // Check if the time difference is greater than 24 hours
    return hoursDiff > hours;
  }
}
